"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsLogoHeader = void 0;
const react_1 = __importDefault(require("react"));
const className_1 = require("../../utils/className");
exports.SmlsLogoHeader = (_a) => {
    var { id, icon = 'smiles', className, styles, width = '100%', height = '100%', onClick } = _a, params = __rest(_a, ["id", "icon", "className", "styles", "width", "height", "onClick"]);
    return (react_1.default.createElement("div", Object.assign({ id: id, className: className_1.mapToCssModules(['smls-logos', icon, className]), style: Object.assign({ width, height }, styles), onClick: onClick }, params)));
};
//# sourceMappingURL=index.js.map